import { motion } from "framer-motion";

const INITIAL = { opacity: 0, y: 18 };
const ANIMATE = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-80px" };
const EASE = [0.22, 1, 0.36, 1];

export default function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={INITIAL}
      whileInView={ANIMATE}
      viewport={VIEWPORT}
      transition={{ duration: 0.7, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
